export enum WorkspaceVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}
